import { createFileRoute } from "@tanstack/react-router"
import PersonaManagementPage from "@/app/persona-management/page"
import { usePageHead } from "../../../compat/head"

export const Route = createFileRoute("/persona-management/$picId/")({
  component: PersonaManagementByPicPage,
})

function PersonaManagementByPicPage() {
  const { picId } = Route.useParams()
  usePageHead({ title: "Cố vấn VuCar" })
  return <PersonaManagementPage picId={picId} />
}
